import Vue from 'vue'
import Components from './components'
import Datepicker from 'vuejs-datepicker';
import CKEditor from '@ckeditor/ckeditor5-vue';
import { EventBus } from './event-bus.js';
import './app.scss'
//import './pdf.scss'
Vue.use( CKEditor );

Vue.config.productionTip = false

new Vue({
  el: '#app',
  delimiters: ['${', '}'],
  data() {
    return {
      loading: false,
      newTitle: ''
    }
  },
  mounted() {
    EventBus.$on('loading', value => {
      this.loading = value;
    });
  }
})
Vue.directive('uppercase',
{
	update (el) {
		el.value = el.value.toUpperCase()
	},
})
